export default {
  eSport: {
    en: {
      1: "ホーム",
      2: "戦隊",
      3: "配信",
      4: "ニュース",
      5: "最新大会",
      6: "戦隊ニュース",
      7: "動画一覧",
      8: "視聴者数",
      9: "紹介",
      10: "選手",
      11: "大会",
      13: "プロフィール",
      14: "戦績",
      15: "参加中",
      16: "視聴する",
      17: "${1}位",
      18: "大会ニュース",
      19: "戦隊ニュース",
      20: "アップデート",
      21: "豆知識",
    },
    zht: {
      1: "首頁",
      2: "俱樂部",
      3: "LIVE",
      4: "資訊",
      5: "最新賽事",
      6: "俱樂部資訊",
      7: "視頻中心",
      8: "播放量",
      9: "介紹",
      10: "選手",
      11: "大會",
      13: "簡介",
      14: "主要成就",
      15: "參戰中",
      16: "觀戰",
      17: "第${1}名",
      18: "賽事新聞",
      19: "戦隊新聞",
      20: "版本更新",
      21: "小知識",
    },
    jp: {
      1: "ホーム",
      2: "戦隊",
      3: "配信",
      4: "ニュース",
      5: "最新大会",
      6: "戦隊ニュース",
      7: "動画一覧",
      8: "視聴者数",
      9: "紹介",
      10: "選手",
      11: "大会",
      13: "プロフィール",
      14: "戦績",
      15: "参加中",
      16: "視聴する",
      17: "${1}位",
      18: "大会ニュース",
      19: "戦隊ニュース",
      20: "アップデート",
      21: "豆知識",
    },
  },
};
